import { render } from "./Sucesso.vue?vue&type=template&id=5a86ea48"
const script = {}
script.render = render

export default script